import { render, staticRenderFns } from "./kalemrentacar.vue?vue&type=template&id=3a2b96c7&"
import script from "./kalemrentacar.vue?vue&type=script&lang=js&"
export * from "./kalemrentacar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports